import { Box, Typography } from '@mui/material';
import { PageType } from 'components/page-context/PageMetaDatas';
import { useRef } from 'react';
import { menuRightStyle } from '../components/styles/tenant-page';
import { useTenantPageTelemetry } from './hooks/useTenantPageTelemetry';

interface TenantPageProps {
  title: string;
  subtitle?: string;
  entityCode?: string;
  menuRight?: React.ReactNode;
  children: React.ReactNode;
  hideBreadcrumbs?: boolean; // Inutilizzato se i breadcrumbs sono globali nella navbar, ma preservato per evitare errori di compilazione
  pageType?: PageType;
}

export const TenantPage = ({
  title,
  subtitle,
  children,
  menuRight,
  entityCode,
  pageType
}: TenantPageProps) => {
  // Riferimento al container di questa specifica pagina per isolare le query DOM
  const pageRef = useRef<HTMLDivElement>(null);

  // Isolated layout performance telemetry tracking hook
  const { page } = useTenantPageTelemetry({ title, entityCode, pageType, pageRef });

  return (
    <div
      ref={pageRef}
      className="w-full"
      id="tenant-page-root"
      data-page-description={page?.description ?? ''}
      data-page-key-actions={page?.key_actions ?? ''}>
      {/* Intestazione di Pagina: Titolo, Sottotitolo e Pulsanti d'azione orizzontali */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-2 mb-2">
        <div className="flex flex-col items-start text-left min-w-0">
          <Box pb={2}>
            <Typography variant="h5" fontWeight={700} sx={{ color: '#1c1f23' }}>
              {title}
            </Typography>
            {subtitle && (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 0.5, lineHeight: '1.5' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </div>

        {/* Contenitore pulsanti d'azione (es. Nuovo, Salva, Esporta) */}
        {menuRight && <Box {...menuRightStyle}>{menuRight}</Box>}
      </div>

      {/* Area del Contenuto Principale della Pagina */}
      <div className="w-full animate-fade-in pb-24">{children}</div>
    </div>
  );
};

export default TenantPage;
